// import Title from "./Title";

function Feature({ name, children }) {
  return (
    <>
      {/* desktop */}
      <div className="hidden lg:flex justify-center">
        <div className="flex flex-col items-start gap-2 text-gray-500 text-lg w-full ">
          {/* <Title name={name}></Title> */}
          <div className="flex flex-row items-center text-main gap-3 px-4">
            <div>
              <img
                src="./cookie.webp"
                className="h-6 w-6 md:h-8 md:w-8"
                alt=""
              ></img>
            </div>
            <div className="text-lg md:text-xl lg:text-2xl tracking-widest font-bold">
              {name}
            </div>
          </div>
          <div className="tracking-wider pl-16 -ml-1">{children}</div>
        </div>
      </div>
      {/* mobile */}
      <div className="flex lg:hidden justify-center pb-8">
        <div className="flex flex-col items-start text-gray-500 text-md w-full ">
          {/* <Title name={name}></Title> */}
          <div className="flex flex-row items-center text-main gap-3 px-4">
            <div>
              <img src="./cookie.webp" className="h-6 w-6" alt=""></img>
            </div>
            <div className="text-lg md:text-xl tracking-widest font-bold">
              {name}
            </div>
          </div>
          <div className="tracking-wider pl-12 ml-1">{children}</div>
        </div>
      </div>
    </>
  );
}

export default Feature;
